import React from 'react';

const ExperianContext = React.createContext({
  clientId: null,
  subscriberId: null,
});

export default ExperianContext;
